import { render, staticRenderFns } from "./BuildingTag.vue?vue&type=template&id=c32c015a&scoped=true&"
import script from "./BuildingTag.vue?vue&type=script&lang=js&"
export * from "./BuildingTag.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTag.vue?vue&type=style&index=0&id=c32c015a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32c015a",
  null
  
)

export default component.exports